import classNames from "classnames";
import {PropsWithChildren, ReactNode} from "react";

import {FormActionsBar} from "@/components/form/FormActionsBar.tsx";
import FormErrorAlerts from "@/components/form/FormErrorAlerts.tsx";
import {useUnsavedChangesNavigationBlocker} from "@/components/form/hooks/useUnsavedChangesNavigationBlocker.tsx";
import {RequiredFieldsNote} from "@/components/form/requiredFieldsNote/RequiredFieldsNote.tsx";
import {FormContentContainer} from "@/components/layout/FormContentContainer.tsx";
import {ServerErrors} from "@/lib/types/common.ts";

import styles from "./PageForm.module.scss";

export interface FormWrapperProps extends PropsWithChildren {
  title?: ReactNode;
  goBack: () => void;
  serverErrorsState?: ServerErrors;
  formId: string;
  submitText?: string;
  className?: string;
  variant?: "primary" | "secondary";
  customActionsBar?: ReactNode; // Override default actions bar
  hasRequiredFields?: boolean;
}

export const PageForm = ({
  goBack,
  children,
  title,
  serverErrorsState,
  formId,
  className,
  submitText = "Save",
  variant = "primary",
  customActionsBar,
  hasRequiredFields = true,
}: FormWrapperProps) => {
  const {UnsavedChangesModal} = useUnsavedChangesNavigationBlocker({onDiscard: goBack});

  const defaultActionsBar = <FormActionsBar formId={formId} submitText={submitText} onCancel={goBack} />;

  return (
    <>
      <FormContentContainer
        title={title}
        actionsBar={customActionsBar || defaultActionsBar}
        className={classNames(className, styles.pageFormContainer)}
        variant={variant}
      >
        {serverErrorsState?.__all__ && <FormErrorAlerts errors={serverErrorsState?.__all__} className="mb-4" />}
        {hasRequiredFields && <RequiredFieldsNote />}
        {children}
      </FormContentContainer>
      <UnsavedChangesModal />
    </>
  );
};
